import { render, staticRenderFns } from "./UserOverview.vue?vue&type=template&id=1d788622&scoped=true"
import script from "./UserOverview.vue?vue&type=script&lang=js"
export * from "./UserOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d788622",
  null
  
)

export default component.exports